var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTabFeedback(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 6.66658V4.99992C14 3.52716 12.8061 2.33325 11.3333 2.33325H4.66667C3.19391 2.33325 2 3.52716 2 4.99992V11.9999C2 13.4727 3.19391 14.6666 4.66667 14.6666H6M5.33333 1.33325V3.33325M10.6667 1.33325V3.33325M8 14.6666L10.0405 14.0849C10.1499 14.0537 10.2495 13.9951 10.33 13.9147L13.6732 10.5715C14.1089 10.1357 14.1089 9.42917 13.6732 8.99341C13.2374 8.55764 12.5309 8.55764 12.0951 8.99341L8.75192 12.3366C8.67149 12.4171 8.6129 12.5167 8.58171 12.6261L8 14.6666Z",
    stroke: "#667085",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabFeedback);
export default __webpack_public_path__ + "static/media/tab-feedback.7a055f176ce24a99fef3731142ed8d3f.svg";
export { ForwardRef as ReactComponent };